 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"EndSession":"EndSession","EventWizard~eventList~notAllowedMobile":"EventWizard~eventList~notAllowedMobile","EventWizard":"EventWizard","IosWrapper":"IosWrapper","assetManager~layoutEditor~liveEvent~liveEventBreakout":"assetManager~layoutEditor~liveEvent~liveEventBreakout","assetManager":"assetManager","billing":"billing","castTemplates":"castTemplates","cefEvent~chatWidget~layoutEditor~liveEvent~liveEventBreakout":"cefEvent~chatWidget~layoutEditor~liveEvent~liveEventBreakout","cefEvent~layoutEditor":"cefEvent~layoutEditor","layoutEditor":"layoutEditor","cefEvent":"cefEvent","chatWidget":"chatWidget","contactInfo":"contactInfo","development":"development","eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor~opsMonitorDetails":"eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor~opsMonitorDetails","eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor":"eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor","liveEvent":"liveEvent","liveEventBreakout":"liveEventBreakout","eventList~notAllowedMobile~opsMonitor":"eventList~notAllowedMobile~opsMonitor","eventList":"eventList","notAllowedMobile":"notAllowedMobile","opsMonitor":"opsMonitor","opsMonitorDetails":"opsMonitorDetails","inviteForm":"inviteForm","layoutManager":"layoutManager","loginScreen":"loginScreen","logout":"logout","memberManager":"memberManager","notFound":"notFound","opsMonitorTranscoding":"opsMonitorTranscoding","opsWRTCServers":"opsWRTCServers","opssrt":"opssrt","preview":"preview","public":"public","recoverEmail":"recoverEmail","sceneManager":"sceneManager","selftest":"selftest","streamManager":"streamManager","teamManager":"teamManager"}[chunkId]||chunkId) + "." + {"EndSession":"dd0e6377","EventWizard~eventList~notAllowedMobile":"0e809abb","EventWizard":"80fd0ff8","IosWrapper":"5bdd0672","assetManager~layoutEditor~liveEvent~liveEventBreakout":"b6245315","assetManager":"09c2626d","billing":"58f9479d","castTemplates":"f52a121b","cefEvent~chatWidget~layoutEditor~liveEvent~liveEventBreakout":"d5d740aa","cefEvent~layoutEditor":"555cf64a","layoutEditor":"cdef9b2f","cefEvent":"9e144dd2","chatWidget":"1cc783c3","chunk-316db822":"7d8496df","contactInfo":"2ace6f33","development":"9cb4e962","eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor~opsMonitorDetails":"3e354d81","eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor":"2dbe843b","liveEvent":"10601d46","liveEventBreakout":"0e558987","eventList~notAllowedMobile~opsMonitor":"a6ee0afc","eventList":"beeb3f82","notAllowedMobile":"c667bd63","opsMonitor":"b605c8c9","opsMonitorDetails":"1b38a6c1","inviteForm":"b8321f48","layoutManager":"871c7bb5","loginScreen":"c34934e8","logout":"2f0a56de","memberManager":"4ce4841a","notFound":"8c555068","opsMonitorTranscoding":"a4e3731a","opsWRTCServers":"2d91d8aa","opssrt":"e59ba9c1","preview":"d625f119","public":"ff10416b","recoverEmail":"28bbfeb5","sceneManager":"6be0a06d","selftest":"3aba8c3b","streamManager":"4f98f7e9","teamManager":"72404cb3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"EndSession":1,"EventWizard~eventList~notAllowedMobile":1,"EventWizard":1,"IosWrapper":1,"assetManager~layoutEditor~liveEvent~liveEventBreakout":1,"assetManager":1,"billing":1,"castTemplates":1,"cefEvent~chatWidget~layoutEditor~liveEvent~liveEventBreakout":1,"cefEvent~layoutEditor":1,"layoutEditor":1,"cefEvent":1,"chunk-316db822":1,"contactInfo":1,"development":1,"eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor~opsMonitorDetails":1,"eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor":1,"liveEvent":1,"liveEventBreakout":1,"eventList~notAllowedMobile~opsMonitor":1,"eventList":1,"notAllowedMobile":1,"opsMonitor":1,"opsMonitorDetails":1,"inviteForm":1,"layoutManager":1,"loginScreen":1,"memberManager":1,"notFound":1,"opsMonitorTranscoding":1,"opsWRTCServers":1,"opssrt":1,"preview":1,"public":1,"recoverEmail":1,"selftest":1,"streamManager":1,"teamManager":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"EndSession":"EndSession","EventWizard~eventList~notAllowedMobile":"EventWizard~eventList~notAllowedMobile","EventWizard":"EventWizard","IosWrapper":"IosWrapper","assetManager~layoutEditor~liveEvent~liveEventBreakout":"assetManager~layoutEditor~liveEvent~liveEventBreakout","assetManager":"assetManager","billing":"billing","castTemplates":"castTemplates","cefEvent~chatWidget~layoutEditor~liveEvent~liveEventBreakout":"cefEvent~chatWidget~layoutEditor~liveEvent~liveEventBreakout","cefEvent~layoutEditor":"cefEvent~layoutEditor","layoutEditor":"layoutEditor","cefEvent":"cefEvent","chatWidget":"chatWidget","contactInfo":"contactInfo","development":"development","eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor~opsMonitorDetails":"eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor~opsMonitorDetails","eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor":"eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor","liveEvent":"liveEvent","liveEventBreakout":"liveEventBreakout","eventList~notAllowedMobile~opsMonitor":"eventList~notAllowedMobile~opsMonitor","eventList":"eventList","notAllowedMobile":"notAllowedMobile","opsMonitor":"opsMonitor","opsMonitorDetails":"opsMonitorDetails","inviteForm":"inviteForm","layoutManager":"layoutManager","loginScreen":"loginScreen","logout":"logout","memberManager":"memberManager","notFound":"notFound","opsMonitorTranscoding":"opsMonitorTranscoding","opsWRTCServers":"opsWRTCServers","opssrt":"opssrt","preview":"preview","public":"public","recoverEmail":"recoverEmail","sceneManager":"sceneManager","selftest":"selftest","streamManager":"streamManager","teamManager":"teamManager"}[chunkId]||chunkId) + "." + {"EndSession":"00820358","EventWizard~eventList~notAllowedMobile":"2d3773e2","EventWizard":"0dc576ed","IosWrapper":"2314f2b8","assetManager~layoutEditor~liveEvent~liveEventBreakout":"3d009fad","assetManager":"267fdf75","billing":"e91d6034","castTemplates":"ccce402a","cefEvent~chatWidget~layoutEditor~liveEvent~liveEventBreakout":"493cc7da","cefEvent~layoutEditor":"036fb826","layoutEditor":"b6e2b2e5","cefEvent":"dcda5995","chatWidget":"31d6cfe0","chunk-316db822":"2574936b","contactInfo":"8d69575b","development":"08a37444","eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor~opsMonitorDetails":"d7a728db","eventList~liveEvent~liveEventBreakout~notAllowedMobile~opsMonitor":"13138b89","liveEvent":"a6f12b98","liveEventBreakout":"09ebf4c1","eventList~notAllowedMobile~opsMonitor":"4e5251aa","eventList":"85298c4a","notAllowedMobile":"cafc3ab8","opsMonitor":"6e694633","opsMonitorDetails":"ac973ae0","inviteForm":"f7427a0a","layoutManager":"00dbf959","loginScreen":"c0040987","logout":"31d6cfe0","memberManager":"14762cf4","notFound":"ebfcc809","opsMonitorTranscoding":"4f64d591","opsWRTCServers":"6b9d3f61","opssrt":"975c3d29","preview":"bf0f3e26","public":"5b1da07a","recoverEmail":"dbfef101","sceneManager":"31d6cfe0","selftest":"53e6fde3","streamManager":"21f8fb2a","teamManager":"a54c3525"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
